import { render } from "./Ticket.vue?vue&type=template&id=5ddedc1a&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"

import "./Ticket.vue?vue&type=style&index=0&id=5ddedc1a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5ddedc1a"

export default script